import axios from 'axios';
import React, { useState, useRef, useEffect } from 'react';
import { PlayCircle, Download, Save, PauseCircle } from 'react-feather';
import 'react-toastify/dist/ReactToastify.css';
import store from '../../../redux/index';
import { Spinner } from 'reactstrap';
import { useAudioContext } from '../../../hooks/useAudioContext';
import { useTosatify } from '../../../hooks/useTosatify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const ReactSwal = withReactContent(Swal);



const EditorPlayer = (props) => {
  const { text, selectedVoice, setText, volume, speedValue, fileFormatValue } = props;

  const data = {
    target: 'tts',
    input: {
      text: text
    },
    output: {
      type: 'online'
    },
    tts_type: {
      type: selectedVoice.vendor,
      method: 'http',
      voice_name: selectedVoice.value,
      ...(selectedVoice.vendor === 'gemini' && { lang: selectedVoice.voiceLanguage })
    },
    sox: {
      sample_rate: fileFormatValue === 'mu-law' ? 8000 :
        selectedVoice.vendor === 'elevenlabs' ? 44100 :
          // selectedVoice.vendor === 'gemini' ? 24000 :
          selectedVoice.vendor === 'istnetworks' ? 22050 : 16000,
      "channels": selectedVoice.vendor === 'gemini' ? 2 : 1,
      "type": fileFormatValue === 'mu-law' ? 'wav' : fileFormatValue,
      'volume': volume,
      'speed': speedValue,
      "encoding": fileFormatValue === 'mu-law' ? 'mu-law' : null,
    }
  };

  const [isPlaying, setIsPlaying] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [duration, setDuration] = useState(0);
  const userToken = store.getState().auth.login.data.access_token;
  const { tostifySuccess, tostifyError } = useTosatify();
  const [audioName, setAudioName] = useState('');

  const audioRef = useRef(null);

  const handlePlay = async () => {
    console.log('handlePlay from EditorPlayer1111');
    if (text === '') {
      tostifyError('Please enter text');
      return;
    }
    if (selectedVoice.value === '') {
      tostifyError('Please select voice');
      return;
    }

    setIsLoading(true);
    try {
      console.log(data, 'data from editor')
      const res = await axios.post(process.env.REACT_APP_API_BASE_URL + '/inbound/', data, {
        headers: {
          Authorization: `Bearer ${userToken}`
        }
      });

      setIsLoading(false);
      setIsPlaying(true);
      const localPath = res.data.tts.data.local_path;
      setAudioName(localPath.split('/').pop());
      const dataArrAudio = res.data.tts.data.bytes;
      useAudioContext(dataArrAudio, audioRef, setDuration, setIsPlaying, selectedVoice, fileFormatValue);
    } catch (error) {
      setIsLoading(false);
      if (error.response && error.response.status === 405) {
        tostifyError('You have finished your characters limit');
        ReactSwal.fire({
          title: 'Character Limit Reached',
          text: 'You have finished your characters limit. Please contact IST for further assistance.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
      } else {
        tostifyError('An error occurred while generating audio');
      }
    }
  };


  const saveData = {
    wav_name: audioName,
    text: text,
    speaker: {
      name_value: selectedVoice.value,
      name: selectedVoice.label,
      gender: selectedVoice.voiceGender,
      language: selectedVoice.voiceLanguage
    }
  };


  const [saved, setSaved] = useState(false);
  const handleSave = () => {
    if (audioName === '') {
      tostifyError('Please play audio first');
      return;
    }
    const req = axios.post(process.env.REACT_APP_API_BASE_URL + '/save', saveData, {
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    });
    req.then(() => {
      setSaved(true);
    });
    setSaved(true);
    tostifySuccess('Audio saved successfully');
  };

  useEffect(() => {
    setSaved(false);
  }, [audioName, text]);




  const downloadAudio = () => {
    const url = process.env.REACT_APP_API_BASE_URL + '/downloadwav?wav_name=' + audioName;
    fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    })
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const newWindow = window.open(url, audioName, 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
      });
    tostifySuccess('Audio ready to download');
  };

  const handleDownload = () => {
    downloadAudio();
    setAudioName('');
    setSaved(false);
  };

  const handleStop = () => {
    setIsPlaying(false);
    if (audioRef.current) {
      audioRef.current.close();
      tostifySuccess('a new Audio generated successfully');
    }
  };


  if (isPlaying) {
    return (
      <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title="stop">
        <PauseCircle size={50} className="mr-2 text-warning pointer" onClick={handleStop} />
      </span>
    );
  }

  if (isLoading) {
    return (
      <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title="Loading">
        <Spinner color="warning" style={{ width: '3rem', height: '3rem' }} />
      </span>
    );

  }

  return (
    <div>
      <>
        {saved ? (
          <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title="Download">
            <Download size={50} className="mr-2 save-text" onClick={handleDownload} />
          </span>
        ) : (
          <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title="Save">
            <Save size={50} className="mr-2 save-text pointer" onClick={handleSave} />
          </span>
        )}
      </>
      <span className="d-inline-block" tabIndex="0" data-toggle="tooltip" title="Play">
        <PlayCircle size={50} className="mr-2 text-warning" onClick={handlePlay} />
      </span>
    </div>
  );
};

export default EditorPlayer;
